

import { Link } from "react-router-dom";
import '../styles/Header.css'
import { FaTimes, FaWifi } from 'react-icons/fa';
import ThemeToggle from './ThemeToggle';
import { FaBars } from 'react-icons/fa';
import { useState } from 'react';




function Header() {

    const [isOpen, setIsOpen] = useState(false);

   const toggleMenu= () => {
    setIsOpen(!isOpen);
    console.log("just clicke me ");
   }  
    
    return ( 
    <div className = 'header-div bg-light1 text-dark2 dark:text-light1 dark:bg-dark1 py-4 ' >
        <div className = 'header-nav bg-light2 dark:bg-dark2 mx-4 rounded-lg' >
            <ul className = 'header-ul' >
                <li onClick={toggleMenu} className='py-2 px-2 lg:hidden  hover:text-primary'>
                    <FaBars className=' w-12 h-6'/>
                </li>
                <li className = 'py-2 logo' >
                    <a href = '#hero-section' className = 'header-a logo-container hover:text-primary' > 
                    <FaWifi className = 'logo-img text-primary mx-2'/>
                    <span className = 'text-primary'> Jcoteck VTU </span> </a > 
                </li > 
               
                <div
                 className={`${
                    isOpen ? 'left-0' : '-left-full'
                  } fixed top-0 w-2/3 h-full z-30  bg-light2 dark:bg-dark2  p-6 transition-all duration-300 ease-in-out lg:static lg:flex lg:space-x-4 lg:w-auto lg:h-auto md:p-0`}
                
                 >
                    <ul className='flex  flex-col lg:flex-row'>
                        <li onClick={toggleMenu} className='lg:hidden m-2  '>
                            <div className='w-12 h-12 bg-light1 dark:bg-dark1 flex items-center justify-center rounded-full text-dark0 hover:text-primary'>
                                <FaTimes className='w-8 h-8 m-2'/>
                            </div>
                        </li>
                        <li className = 'py-2 ' > 
                            <Link to= '/' className = 'no-underline px-3 my-16 hover:text-primary' > Home </Link>
                        </li >
                        <li className = 'py-2 ' > 
                            <a href = '#feature-section' className = 'no-underline px-3 hover:text-primary ' > Features </a>
                        </li >
                        <li className = 'py-2 ' > 
                            <a href = '#pricing-section' className = 'no-underline px-3 hover:text-primary' > Pricing </a>
                        </li >
                        <li className = 'py-2 ' > 
                            <Link to= '/account' className = 'no-underline px-3 hover:text-primary' > Account </Link>
                        </li >
                        <li className = 'py-2 ' > 
                            <a href = '#faq-section' className = 'no-underline px-3 hover:text-primary' > FAQ </a>
                        </li >
                        <li className = 'py-2 ' > 
                            <a href = '#about-section' className = 'no-underline px-3 hover:text-primary' > About </a>
                        </li >
                        <li className = 'py-2 ' > 
                            <a href = '#contact-section' className = 'no-underline px-4 py-4 hover:text-primary' > Contact </a>
                        </li >
                    </ul>
                   
                </div>
                
                <li>
                    <ThemeToggle className='px-2 hover:text-primary' /> 
                </li>
            </ul>            
        </div >
    </div>
    );
}

export default Header;